import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import type { ReactNode } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useQuickPanelContext } from "./contexts/QuickPanelContext/useQuickPanelContext";
import { Tooltip } from "@mui/material";

type QuickPanelToggleButtonProps = {
	readonly className?: string;
	readonly children?: ReactNode;
};

/**
 * The quick panel toggle button.
 */
function QuickPanelToggleButton(props: QuickPanelToggleButtonProps) {
	const { className = "", children } = props;
	const resolvedChildren = children ?? <FuseSvgIcon>lucide:bell</FuseSvgIcon>;
	const {
		unreadCount,
		actions: { toggleQuickPanel },
	} = useQuickPanelContext();

	return (
		<Tooltip title="Notificações" placement="bottom">
			<IconButton size="small" onClick={toggleQuickPanel} className={className} aria-label="Abrir notificações">
				<Badge color="error" badgeContent={unreadCount} max={99} invisible={unreadCount === 0}>
					{resolvedChildren}
				</Badge>
			</IconButton>
		</Tooltip>
	);
}

export default QuickPanelToggleButton;
